import { render, staticRenderFns } from "./ProductViewerHeader.vue?vue&type=template&id=623cf1fa&scoped=true&"
import script from "./ProductViewerHeader.vue?vue&type=script&lang=js&"
export * from "./ProductViewerHeader.vue?vue&type=script&lang=js&"
import style0 from "./ProductViewerHeader.vue?vue&type=style&index=0&id=623cf1fa&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "623cf1fa",
  null
  
)

export default component.exports